import { render, staticRenderFns } from "./StockKittingTools.vue?vue&type=template&id=bdcd08b6&scoped=true&"
import script from "./StockKittingTools.vue?vue&type=script&lang=js&"
export * from "./StockKittingTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcd08b6",
  null
  
)

export default component.exports
import {QTable,QIcon,QTr,QTh,QTooltip,QTd,QBtn,QBtnDropdown,QCard,QCardSection,QChip,QItemSection,QItem,QInput} from 'quasar'
component.options.components = Object.assign({QTable,QIcon,QTr,QTh,QTooltip,QTd,QBtn,QBtnDropdown,QCard,QCardSection,QChip,QItemSection,QItem,QInput}, component.options.components || {})
